import { EMPTY_VALUE } from '../../constants';
import { normalizeLoadedFormValues } from '../../field-viewer/normalize-loaded-form-values';
import { isObject } from '../../field-viewer/type-guards';
export function normalizeRepeater({ field, fieldValue, addressTemplates, viewers }) {
    const isEmptyValue = fieldValue === EMPTY_VALUE;
    const nestedFields = field.view?.fields;
    if (isEmptyValue) {
        return fieldValue;
    }
    if (!Array.isArray(fieldValue) || !nestedFields) {
        return EMPTY_VALUE;
    }
    const nestedForm = {
        fields: nestedFields
    };
    const normalizedValues = fieldValue.map((values)=>{
        if (!isObject(values)) {
            return {};
        }
        const normalized = normalizeLoadedFormValues(viewers, nestedForm, values, false, addressTemplates);
        return Object.fromEntries(Object.entries(normalized).filter(([_, value])=>value !== EMPTY_VALUE));
    });
    return normalizedValues;
}

//# sourceMappingURL=events-repeater-normalize-value.js.map